import { EntityElastic } from '../../types/entity'

export const isMovie = (item?: EntityElastic) =>
    item?.extended_attributes?.htIsMovie || item?.showType?.[0]?.slug === 'rtlhr-taxon-show-type-movie'
